import React from "react";
import ReactDOM from "react-dom/client";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
      <PrivacyPolicy />
  </React.StrictMode>
);


